import React from "react";

import Header from "../Header";
import Footer from "../Footer";
import PTLHeader from "../PTLHeader";
import PTLFooter from "../PTLFooter";
import CookieConsent from "../CookieConsent";

import { Helmet } from "react-helmet";

const ORG_SCHEMA = JSON.stringify({
  "@context": "https://schema.org",
  "@type": "Organization",
  name: "Prozo Integrated Logistics Private Limited",
  alternateName: "Prozo",
  url: "https://www.prozo.com",
  logo: "https://www.prozo.com/media/logo.svg",
  description:
    "End-to-end supply chain solutions: warehousing, fulfilment, logistics, and technology across India. 50+ warehouses, ~3M sq ft, 30+ courier partners.",
  foundingDate: "2015",
  telephone: "+919311847248",
  email: "sales@prozo.com",
  address: {
    "@type": "PostalAddress",
    streetAddress:
      "Enkay Tower, Plot B&B1, A Wing, 3rd Floor, Vanijya Nikunj, Udyog Vihar Phase V",
    addressLocality: "Gurugram",
    addressRegion: "Haryana",
    postalCode: "122016",
    addressCountry: "IN",
  },
  areaServed: { "@type": "Country", name: "India" },
  sameAs: [
    "https://www.linkedin.com/company/prozo",
    "https://twitter.com/prozodotcom",
    "https://www.facebook.com/proship.by.prozo",
  ],
});

function AppLayout({ children, location }) {
  const hideHederOnUrl = ["d2c-shipping-services", "ptl-ftl-services"];
  const isPTLPage = hideHederOnUrl.some((url) =>
    location?.pathname.includes(url)
  );

  const hideCookieOnUrl = ["courier-aggregator", "logistics-service-provider", "ecommerce-shipping"];
  const hideCookie = hideCookieOnUrl.some((url) =>
    location?.pathname.includes(url)
  );

  // Choose appropriate header and footer components
  const HeaderComponent = isPTLPage || hideCookie ? PTLHeader : Header;
  const FooterComponent = isPTLPage || hideCookie ? PTLFooter : Footer;
  return (
    <React.Fragment>
      <Helmet>
        <link rel="icon" href="/images/favicon.png" type="image/png" />
        <script type="application/ld+json">{ORG_SCHEMA}</script>
        <script
          type="text/javascript"
          src="/js/jquery.easing.min.js"
          key="jquery.easing.min"></script>
        <script
          type="text/javascript"
          src="/js/scrollspy.min.js"
          key="scrollspy.min"></script>
        <script type="text/javascript" src="/js/app.js" key="app-js"></script>
      </Helmet>

      <a
        href="#main-content"
        className="visually-hidden-focusable"
        style={{
          position: "absolute",
          top: "-100px",
          left: "8px",
          zIndex: 9999,
          padding: "8px 16px",
          background: "#1a1a2e",
          color: "#fff",
          borderRadius: "0 0 6px 6px",
          fontSize: "14px",
          textDecoration: "none",
          transition: "top 0.2s",
        }}
        onFocus={(e) => { e.currentTarget.style.top = "0"; }}
        onBlur={(e) => { e.currentTarget.style.top = "-100px"; }}
      >
        Skip to main content
      </a>

      <HeaderComponent hideMenu={hideCookie} showOffer={isPTLPage} />
      <div id="main-content">{children}</div>
      <FooterComponent addClass="bg-gray" />
      {!isPTLPage && !hideCookie && <CookieConsent />}
    </React.Fragment>
  );
}

export default AppLayout;
